var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roles"},[_c('tz-card',{attrs:{"title":"角色创建","url":"/roles","btnTitle":"返回"}},[_c('tz-form',{attrs:{"width":"80px","formConfig":_vm.formConfig,"formBtns":_vm.formBtns},on:{"submit":_vm.submitFn}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }